import { render, staticRenderFns } from "./EventExternalReplyView.vue?vue&type=template&id=31900a12&scoped=true"
import script from "./EventExternalReplyView.vue?vue&type=script&lang=js"
export * from "./EventExternalReplyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31900a12",
  null
  
)

export default component.exports